<div
  class="fb-field-wrapper"
  [class.fb-field-wrapper--selected]="isSelected"
  [class.fb-field-wrapper--hidden]="isHidden"
  [class.fb-field-wrapper--non-display]="isNonDisplay"
  (click)="onSelect($event)"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">
  <!-- Visible field -->
  <ng-container *ngIf="isVisible">
    <!-- Header row: label + toolbar (matching V1 field-wrapper layout) -->
    <header class="fb-field-wrapper__header">
      <span class="fb-field-wrapper__tooltip" *ngIf="tooltipText">
        <i class="fas fa-circle-info" [title]="tooltipText"></i>
      </span>
      <small class="fb-field-wrapper__label" (click)="$event.stopPropagation()">
        <irembogov-fb-inline-edit
          [value]="rawLabel"
          placeholder="Field label"
          (valueChange)="onLabelChange($event)"></irembogov-fb-inline-edit
        ><sup *ngIf="isRequired" class="fb-field-wrapper__required">*</sup>
      </small>
      <div
        class="fb-field-wrapper__toolbar"
        *ngIf="
          (showToolbar || isSelected) && !reviewMode && !isNonConfigurable
        ">
        <i
          class="fb-field-wrapper__toolbar-icon"
          [class]="keyCopied ? 'fa-solid fa-check text-success' : 'icon-key-01'"
          [title]="keyCopied ? 'Copied!' : 'Key: ' + fieldKey"
          (click)="copyKey(); $event.stopPropagation()"></i>
        <i
          class="fas fa-clone fb-field-wrapper__toolbar-icon"
          title="Duplicate"
          (click)="duplicate(); $event.stopPropagation()"></i>
        <i
          *ngIf="isLocationWidgetRoot"
          class="fas fa-map-location-dot fb-field-wrapper__toolbar-icon"
          title="Configure Location"
          (click)="configureLocation(); $event.stopPropagation()"></i>
        <i
          class="fas fa-cog fb-field-wrapper__toolbar-icon"
          title="Configure"
          (click)="configure(); $event.stopPropagation()"></i>
        <i
          class="fas fa-trash-can fb-field-wrapper__toolbar-icon"
          title="Delete"
          (click)="delete(); $event.stopPropagation()"></i>
      </div>
    </header>

    <!-- Field content: actual formly rendering with proper context -->
    <div class="fb-field-wrapper__content">
      <formly-form
        [form]="previewForm"
        [fields]="previewFields"
        [model]="previewModel"
        [options]="previewOptions">
      </formly-form>
    </div>

    <em *ngIf="internalDescription" class="fb-field-wrapper__description">
      <i class="fa-solid fa-square-pen"></i>
      {{ internalDescription }}
    </em>
  </ng-container>

  <!-- Hidden/Non-Display placeholder -->
  <ng-container *ngIf="!isVisible">
    <div class="fb-field-wrapper__placeholder">
      <span class="fb-field-wrapper__status-label">
        <span
          class="badge"
          [class.bg-info]="isHidden"
          [class.bg-warning]="isNonDisplay">
          <i
            [class]="
              isHidden ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'
            "></i>
          {{ isHidden ? 'Hidden Field' : 'Non-Display Field' }}
        </span>
      </span>
      <div class="fb-field-wrapper__placeholder-title">
        <strong class="text-muted" (click)="$event.stopPropagation()">
          <i class="icon-file-06"></i>
          <irembogov-fb-inline-edit
            [value]="rawLabel"
            placeholder="Field label"
            (valueChange)="onLabelChange($event)"></irembogov-fb-inline-edit>
        </strong>
        <div
          class="fb-field-wrapper__toolbar"
          *ngIf="
            (showToolbar || isSelected) && !reviewMode && !isNonConfigurable
          ">
          <i
            class="fb-field-wrapper__toolbar-icon"
            [class]="
              keyCopied ? 'fa-solid fa-check text-success' : 'icon-key-01'
            "
            [title]="keyCopied ? 'Copied!' : 'Key: ' + fieldKey"
            (click)="copyKey(); $event.stopPropagation()"></i>
          <i
            class="fas fa-clone fb-field-wrapper__toolbar-icon"
            title="Duplicate"
            (click)="duplicate(); $event.stopPropagation()"></i>
          <i
            *ngIf="isLocationWidgetRoot"
            class="fas fa-map-location-dot fb-field-wrapper__toolbar-icon"
            title="Configure Location"
            (click)="configureLocation(); $event.stopPropagation()"></i>
          <i
            class="fas fa-cog fb-field-wrapper__toolbar-icon"
            title="Configure"
            (click)="configure(); $event.stopPropagation()"></i>
          <i
            class="fas fa-trash-can fb-field-wrapper__toolbar-icon"
            title="Delete"
            (click)="delete(); $event.stopPropagation()"></i>
        </div>
      </div>
      <small class="fb-field-wrapper__meta">
        <i class="icon-key-01"></i> {{ fieldKey }}
        &nbsp;|&nbsp;
        <i class="fa-solid fa-cube"></i> {{ fieldType }}
      </small>
    </div>
  </ng-container>
</div>
